import { FxmsData } from "./FxData";
import { FxAction } from "../actions/FxAction";

/**
 * 기능항목 속성을 갖는다.
 *
 * 개발자 : T/F팀
 * 개발년월 : 2022.11.
 */
export class OpClass {

  static map = new Map();

  static getOpClass(opId) {
    let opClass = OpClass.map.get(opId);
    if (opClass === undefined || opClass === null) {
      const opObj = FxmsData.getOpObj(opId);
      if (opObj) {
        opClass = new OpClass(opObj);
        OpClass.map.set(opId, opClass);
        console.log("*** OpClass ***  New ", opId);
      }
    }
    return opClass;
  }


  constructor(opObj, attrList) {

    this.opObj = opObj;
    this.attrList = new AttrList(opObj.opId);

    let list = attrList ? attrList : opObj && opObj.attrList ? opObj.attrList : [];

    for (const attr of list) {
      this.attrList.add(attr, new AttrClass(attr));
    }

    this.attrList.parseAttr();
  }

  getAttrListClass() {
    return this.attrList;
  }

  getInputList() {
    return this.attrList.getInputList();
  }

  getButtonList() {
    return this.attrList.getButtonList();
  }

  getAttrClassList() {
    return this.attrList.getAttrClassList();
  }

  isSelect() {
    return this.opObj && this.opObj.opTypeCd.toLowerCase() === "select";
  }
  isInsert() {
    return this.opObj && this.opObj.opTypeCd.toLowerCase() === "insert";
  }
  isUpdate() {
    return this.opObj && this.opObj.opTypeCd.toLowerCase() === "update";
  }
  isDelete() {
    return this.opObj && this.opObj.opTypeCd.toLowerCase() === "delete";
  }
  isUi() {
    return this.opObj && this.opObj.opTypeCd.toLowerCase() === "ui";
  }

  getAttrValue(attrName, defVal) {
    return this.attrList.getAttrValue(attrName, defVal);

  }

  getAttrClass(attrName) {
    return this.attrList.getAttrClass(attrName);
  }

  getAttrList(attrTypeCd) {
    return this.attrList.getAttrList(attrTypeCd);
  }

  getAttrSort() {
    return this.attrList.getAttrSort();
  }

  getCloseButtonAttrClass() {
    return this.attrList.getCloseButtonAttrClass();
  }

  getMaxWidth() {
    return this.attrList.getMaxWidth();
  }

  /**
   * 데이터 편집할 때 최대 가로 크기
   */
  getColSize() {
    return this.attrList.getColSize();
  }

  getAttrInfo() {
    return this.attrList.getAttrInfo();
  }

  getOpObj() {
    return this.opObj;
  }

}


/**
 * 기능을 구성하는 속성의 속성을 갖는다.
 *
 * 개발자 : T/F팀
 * 개발년월 : 2022.11.
 */
export class AttrClass {
  static ATTR_GRP_INPUT = "input";
  static ATTR_GRP_FILTER = "filter";
  static ATTR_GRP_GRID = "grid";
  static ATTR_GRP_SORT = "sort";
  static ATTR_GRP_TOOLBAR = "toolbar";
  static ATTR_GRP_FIELD = "field";
  static ATTR_GRP_BUTTON = "button";
  static ATTR_GRP_VALUE = "fixedValue";

  constructor(attr) {
    this.attr = attr;
    this.linkOpClass = OpClass.getOpClass(attr.linkOpId);
    if (attr.etcInfo) {
      try {
        this.etcInfoObj = JSON.parse(attr.etcInfo);
      } catch (error) {
        this.etcInfoObj = {};
      }
    }
  }

  getId() {
    return this.attr.attrName;
  }

  onChange(datas) {
    if (this.changeCall) {
      this.changeCall(datas);
    } else if (this.attr.onChange) {
      this.attr.onChange(datas);
    }
  }
  /**
   *
   * @param {*} datas 입력 또는 선택된 값
   * @param {*} id 입력이면 null 선택되었을땐 값의 ID
   */
  onClick(datas, id, callback) {
    if (this.clickCall) {
      this.clickCall(datas, id);
    } else if (this.attr.onClick) {
      this.attr.onClick(datas, id);
    } else {
      new FxAction(this.getAttr(), datas, id, callback).click();
    }
  }
  callback(datas) {
    if (this.Call) {
      this.Call(datas);
    } else if (this.attr.callback) {
      this.attr.callback(datas);
    }
  }

  setOnChange(onChange) {
    this.changeCall = onChange;
  }
  setOnClick(onClick) {
    this.clickCall = onClick;
  }
  setCallback(callback) {
    this.Call = callback;
  }

  getAttr() {
    return this.attr;
  }

  getName() {
    return this.attr.attrName;
  }

  isGridKey() {
    return this.attr.attrGrp === "grid" || this.attr.keyIndex > 0;
  }

  /**
   * 선택된 데이터가 있어야 하는지 확인하는 함수
   */
  isNeedData() {
    return this.isButton() && this.linkOpClass && (
      this.linkOpClass.isUpdate() ||
      this.linkOpClass.isDelete() ||
      this.linkOpClass.isUi()
    )
      ;
  }

  isButton() {
    return (
      this.attr.attrTypeCd && this.attr.attrTypeCd.toLowerCase() === "button"
    );
  }

  isCloseButton() {
    return (
      this.isButton() &&
      this.attr.attrDftVal &&
      this.attr.attrDftVal.toLowerCase() === "close"
    );
  }

  /**
   * 자동으로 조회하는 버튼인지 여부
   * @returns
   */
  isAutoSelectButton() {
    if (this.isButton() && this.linkOpClass && this.linkOpClass.isSelect()) {
      return this.attr.attrDftVal.toLowerCase() === "select";
    }
    return false;
  }

  isSelectBox() {
    return (
      this.attr.attrTypeCd && this.attr.attrTypeCd.toLowerCase() === "select"
    );
  }

  isDisable() {
    return this.attr.readOnlyYn === "Y";
  }

  isNullable() {
    return this.attr.nulblYn === "Y";
  }

  getLinkOpObj() {
    return this.linkOpClass ? this.linkOpClass.getOpObj() : undefined;
  }
  getLinkOpClass() {
    return this.linkOpClass;
  }

  getEtcInfoObj() {
    return this.etcInfoObj;
  }

  getStyle() {
    const sx = {};
    if (this.attr.uiWidth > 0) {
      sx.minWidth = this.attr.uiWidth + "px";
      sx.width = this.attr.uiWidth + "px";
    } else {
      // sx.width = '100%';
    }
    return sx;
  }

  static initAttr(attr, opMap) {
    // 선택된 데이터가 있어야 하는지 확인하는 함수
    attr.isNeedData = function () {
      return (
        attr.attrTypeCd === "button" &&
        (attr.attrDftVal === "delete" ||
          attr.attrDftVal === "update" ||
          attr.attrDftVal === "show")
      );
    };

    // 버튼여부 함수 생성
    attr.isButton = function () {
      return attr.attrTypeCd && attr.attrTypeCd.toLowerCase() === "button";
    };
    attr.isCloseButton = function () {
      return (
        attr.isButton() &&
        attr.attrDftVal &&
        attr.attrDftVal.toLowerCase() === "close"
      );
    };
    attr.isSelectBox = function () {
      return attr.attrTypeCd && attr.attrTypeCd.toLowerCase() === "select";
    };

    if (attr.isButton()) {
      attr.datas = {};
    }

    attr.isNullable = function () {
      return attr.nulblYn !== "N";
    };

    if (attr.linkOpId) {
      attr.linkOpObj = opMap
        ? opMap.get(attr.linkOpId)
        : FxmsData.getOpObj(attr.linkOpId);
    }

    // 기타정보 설정
    attr.etcInfoObj = {};
    if (attr.etcInfo) {
      try {
        attr.etcInfoObj = JSON.parse(attr.etcInfo);
      } catch (error) { }
    }
  }
}


/**
 * 화면을 구성하는 속성 목록
 *
 * 개발자 : T/F팀
 * 개발년월 : 2022.11.
 */

export class AttrList {

  constructor(opId) {
    this.opId = opId;
    this.INDEX = 1;
    this.attrList = [];
    this.attrClassList = [];
    this.labelWidth = '200px';
  }

  setLabelWidth(width) {
    this.labelWidth = width;
  }

  getLabelWidth() {
    return this.labelWidth;
  }

  clear() {
    this.INDEX = 1;
    this.attrList = [];
    this.attrClassList = [];
  }

  add(attr, attrClass) {
    this.attrList.push(attr);
    this.attrClassList.push(attrClass);
    this.parseAttr();
  }

  make(attrName, attrUiTxt, attrTypeCd, attrValList) {
    const attr = {
      opId: this.opId,
      attrGrp: this.opId,
      attrName: attrName,
      sortSeq: this.INDEX++,
      attrUiTxt: attrUiTxt,
      attrTypeCd: attrTypeCd,
      attrDftVal: undefined,
      attrValList: attrValList,
      prmptText: undefined,
      readOnlyYn: "N",
      nulblYn: "Y",
      linkOpId: "",
      uiWidth: 0,
      funcName: "",
      etcInfo: "",
      hideYn: "N",
      keyIndex: -1,
      etcInfoObj: {},
    };

    AttrClass.initAttr(attr);
    this.add(attr, new AttrClass(attr));
    return attr;
  }

  addButton(text, onClick, etcInfo = "left") {
    const attrName = "btn" + this.sortSeq;
    const attr = this.make(attrName, text, "button");
    attr.onClick = onClick;
    attr.uiWidth = 140;
    attr.etcInfo = etcInfo;
    return attr;
  }

  addSelect(attrName, text, type, onChange, etcInfo = "right") {
    const attr = this.make(attrName, text, "select", type);
    attr.onChange = onChange;
    attr.etcInfo = etcInfo;
    return attr;
  }

  addColumn(attrName, text, attrTypeCd, uiWidth) {
    const attr = this.make(attrName, text, attrTypeCd);
    attr.uiWidth = uiWidth;
    return attr;
  }

  addDate(attrName, text, etcInfo = "left") {
    const attr = this.make(attrName, text, "date");
    attr.uiWidth = 140;
    attr.etcInfo = etcInfo;
    return attr;
  }

  addDateMonth(attrName, text, etcInfo = "left") {
    const attr = this.make(attrName, text, "dateMonth");
    attr.uiWidth = 140;
    attr.etcInfo = etcInfo;
    return attr;
  }

  addLabel(text, etcInfo = "left") {
    const attr = this.make("label", text, "label");
    attr.uiWidth = 140;
    attr.etcInfo = etcInfo;
    return attr;
  }

  addTitle(text, etcInfo = "left") {
    const attr = this.make("title", text, "title");
    attr.uiWidth = 140;
    attr.etcInfo = etcInfo;
    return attr;
  }

  getList() {
    return this.attrList;
  }

  getAttrClassList() {
    return this.attrClassList;
  }

  getInputList() {
    return this.inputList;
  }

  getButtonList() {
    return this.buttonList;
  }

  getAttrValue(attrName, defVal) {
    for (let attr of this.attrList) {
      if (attr.attrName === attrName) {
        if (typeof defVal === "number") {
          return parseInt(attr.attrDftVal);
        } else if (typeof defVal === "boolean") {
          return attr.attrDftVal === "Y" || attr.attrDftVal === "y";
        } else {
          return attr.attrDftVal;
        }
      }
    }
    return defVal;
  }

  getAttrClass(attrName) {
    for (let attrClass of this.attrClassList) {
      if (attrClass.attr.attrName === attrName) {
        return attrClass;
      }
    }
  }

  getAttrList(attrTypeCd) {
    const ret = [];

    for (let attr of this.attrList) {
      if (attr.attrTypeCd === attrTypeCd) {
        ret.push(attr);
      }
    }

    return ret;
  }

  getAttrSort() {
    for (let attr of this.attrList) {
      if (attr.attrGrp === "sort") {
        return attr;
      }
    }
    return undefined;
  }

  getCloseButtonAttrClass() {
    for (let attrClass of this.attrClassList) {
      if (attrClass.isCloseButton()) {
        return attrClass;
      }
    }
    return undefined;
  }

  getMaxWidth() {
    let maxWidth = 0;
    let lineNum;
    let map = new Map();
    for (const attr of this.attrList) {
      lineNum = parseInt(attr.sortSeq / 10);
      let width = map.get(lineNum);
      width = width == null ? attr.uiWidth : width + attr.uiWidth;
      width += 300; // label
      map.set(lineNum, width);

      if (width > maxWidth) {
        maxWidth = width;
      }
    }

    maxWidth += 260; // 좌우 마진

    return AttrList.makeWidth(maxWidth);

  }

  static makeWidth(num) {

    return num < 600
      ? "xs" //
      : num < 960
        ? "sm" //
        : num < 1280
          ? "md" //
          : num < 1920
            ? "lg"
            : "xl";

    // xs (extra-small) : 0px ~ 600px
    // sm (small) : 600px ~ 960px
    // md (medium): 960px ~ 1280px
    // lg (large) : 1280px ~ 1920px
    // xl (extra-large) : 1920px ~
  }

  /**
   * 데이터 편집할 때 최대 가로 크기
   */
  getColSize() {
    let size = 1;
    for (const line of this.inputList) {
      if (line.length > size) {
        size = line.length;
      }
    }
    return size;
  }

  parseAttr() {
    const ret = [];
    this.buttonList = [];
    let map = new Map();
    let lineNum;

    for (let attrClass of this.attrClassList) {
      const attr = attrClass.getAttr();
      lineNum = parseInt(attr.sortSeq / 10);
      let line = map.get(lineNum);

      // 버튼인데 같은 라인이 비워있으면 버튼목록으로 넣는다.
      // 일단 보류
      if (attr.isButton()) {
        this.buttonList.push(attrClass);
        continue;
      }


      if (line == null) {
        line = [];
        map.set(lineNum, line);
      }
      line.push(attrClass);
    }

    this.inputList = Array.from(map.values());
  }


  getAttrInfo() {
    let filterList = [];
    let toolbarAttrList = [];
    let gridAttrList = [];
    let idAttrList = [];
    let sortAttr;
    let initOpClass = null;

    for (let attrClass of this.attrClassList) {
      const attr = attrClass.getAttr();
      // 버튼인데 권한이 없으면 무시한다.
      if (attrClass.isButton() && attrClass.getLinkOpObj() === null) {
        continue;
      }

      if (attr.attrGrp === "filter") {
        filterList.push(attr);
        if (attrClass.isAutoSelectButton()) {
          initOpClass = attrClass.getLinkOpClass();
        }
      } else if (attr.attrGrp === "toolbar") {
        toolbarAttrList.push(attr);
      } else if (attr.attrGrp === "grid") {
        if (attr.keyIndex > 0) {
          idAttrList.push(attr);
        }
        if (attr.hideYn === "Y") continue;
        gridAttrList.push(attr);
      } else if (attr.attrGrp === "sort") {
        sortAttr = attr;
      }
    }

    return [
      filterList,
      toolbarAttrList,
      gridAttrList,
      sortAttr,
      initOpClass,
      idAttrList,
    ];
  }
}


/**
 * 화면을 구성하는 속성 목록
 *
 * 개발자 : T/F팀
 * 개발년월 : 2022.11.
 */
export class AttrListEdit extends AttrList {

  makeAttrSeparator(sortSeq) {
    const attr = this.make("separator", "", "separator", null);
    attr.sortSeq = sortSeq;
    return attr;
  }

  makeAttrText(sortSeq, attrName, attrUiText, uiWidth) {
    const attr = this.make(attrName, attrUiText, "text", null);
    attr.sortSeq = sortSeq;
    attr.uiWidth = uiWidth;
    return attr;
  }

  makeAttrButton(sortSeq, attrName, attrUiText, uiWidth, linkOpId, onClick) {
    const attr = this.make(attrName, attrUiText, "button", null);
    attr.sortSeq = sortSeq;
    attr.uiWidth = uiWidth;
    attr.linkOpId = linkOpId;
    attr.onClick = onClick;
    return attr;
  }

  makeAttrCheck(sortSeq, attrName, attrUiText, uiWidth, onChange = null) {
    const attr = this.make(attrName, attrUiText, "checkbox", null);
    attr.sortSeq = sortSeq;
    attr.uiWidth = uiWidth;
    attr.onChange = onChange;
    return attr;
  }

  makeAttrSelect(sortSeq, attrName, attrUiText, uiWidth, attrValType, attrValObj, onChange = null) {
    const attr = this.make(attrName, attrUiText, "select", null);
    attr.sortSeq = sortSeq;
    attr.uiWidth = uiWidth;
    attr.onChange = onChange;
    attr.attrValType = attrValType;
    attr.attrValObj = attrValObj;
    return attr;
  }
}
